module.exports = __webpack_public_path__ + "static/blog-2-baeb238d3ddb25529bb1cd3390f6db91.jpg";